import {
  isGroupAdmin,
  isUnitAdmin,
  isSchoolAdmin,
} from 'modules/Users/Permissions/UserType';

const INSTITUTION_LEVELS = ['group', 'unit', 'school'];

/**
 * Which institution levels a user type is supposed to see in the header.
 *
 * - Group Admin  -> Group ID
 * - Unit Admin   -> Group ID + Unit ID
 * - School Admin -> Group ID + Unit ID + School ID
 *
 * Any other user type (Super Admin, Evaluator, Teacher, ...) sees nothing.
 */
const getInstitutionLevels = (userType) => {
  if (typeof userType !== 'string' || !userType) return [];

  if (isSchoolAdmin(userType)) return ['group', 'unit', 'school'];
  if (isUnitAdmin(userType)) return ['group', 'unit'];
  if (isGroupAdmin(userType)) return ['group'];

  return [];
};

/**
 * Builds the list of ids to render, keeping only the levels that actually came
 * in the authentication payload (the API sends `null` for the levels that do
 * not apply to the logged user).
 *
 * @param {Object} user the authenticated user (`authData.user`)
 * @returns {Array<{ level: string, id: number|string }>}
 */
const getInstitutionIds = (user) =>
  getInstitutionLevels(user?.user_type)
    .map((level) => ({ level, id: user?.[level]?.id }))
    .filter(({ id }) => id !== null && id !== undefined && id !== '');

export { INSTITUTION_LEVELS, getInstitutionLevels, getInstitutionIds };
